module.exports = __webpack_public_path__ + "img/SmallCorner.d848bcc1.png";